var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRingCardNavyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 43,
    viewBox: "0 0 50 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.7249,
    cy: 32,
    r: 25.5,
    stroke: "#24234F",
    strokeWidth: 13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingCardNavyBlue);
export default __webpack_public_path__ + "static/media/ring_card_navy_blue.438313b1e9831aafcc992e87d5075dd5.svg";
export { ForwardRef as ReactComponent };